import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const COLUMN_CLASS = {
  2: '@sm:grid-cols-2',
  4: '@sm:grid-cols-2 @3xl:grid-cols-4',
} as const;

type FormSectionColumnCount = keyof typeof COLUMN_CLASS;

interface FormSectionProps {
  columnCount?: FormSectionColumnCount | undefined;
  children: ReactNode;
}

export function FormSection({ columnCount = 2, children }: FormSectionProps) {
  return (
    <section className="@container rounded-xl bg-primary/3 p-3.5 ring-1 ring-primary/8">
      <div className={cn('grid gap-x-3 gap-y-4', COLUMN_CLASS[columnCount])}>{children}</div>
    </section>
  );
}
